export default "__VITE_ASSET__1aeXEXXv__"